import dynamic from 'next/dynamic';

import { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';

const CompactVariantSelector = dynamic<React.PropsWithChildren<unknown>>(() =>
  import('./CompactVariantSelector').then((mod) => mod.CompactVariantSelector),
);
const GQLVariantSelector = dynamic<React.PropsWithChildren<unknown>>(() =>
  import(
    '@/productDiscovery/ProductPage/common/components/VariantSelector/CompactVariantSelector'
  ).then((mod) => mod.CompactVariantSelector),
);

export const LazyCompactVariantSelector = () => {
  const { variants, isSellable, variantExperience } = useDetail();

  if (!isSellable) return null;

  if (variantExperience === 'REGULAR') {
    return <GQLVariantSelector />;
  }

  if (variants?.list?.length) return <CompactVariantSelector />;

  return null;
};
